import React from "react";
import { Trash2, Rocket } from "lucide-react";
import { APP } from "@/constants/testIds";

export default function SavedIdeaCard({ saved, onDelete, onDeepDive }) {
  const { idea } = saved;
  return (
    <div data-testid={APP.savedItem} className="brutal-border p-6 relative">
      <div className="flex items-start justify-between gap-2 mb-3">
        <span className="tag">{idea.category}</span>
        <button
          data-testid={APP.savedDeleteBtn}
          onClick={() => onDelete(saved.id)}
          className="text-[color:var(--muted)] hover:text-[color:var(--hot)]"
          aria-label="Delete saved idea"
        >
          <Trash2 size={16} />
        </button>
      </div>
      <h3 className="font-display text-2xl leading-tight">{idea.title}</h3>
      <p className="text-sm text-[color:var(--muted)] mt-2 italic">{idea.tagline}</p>
      <p className="text-sm mt-4 leading-relaxed">{idea.description}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {idea.tags.map((t) => (
          <span key={`${saved.id}-tag-${t}`} className="tag">{t}</span>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-[color:var(--line)] grid grid-cols-3 gap-2 text-xs">
        <Cell label="Cost" value={idea.startup_cost} />
        <Cell label="Skill" value={idea.skill_level} />
        <Cell label="Score" value={idea.trend_score} />
      </div>
      <button
        onClick={() => onDeepDive(idea)}
        data-testid={APP.ideaDeepDiveBtn}
        className="mt-4 w-full py-2.5 border border-[color:var(--fg)] text-xs uppercase tracking-widest font-semibold hover:bg-[color:var(--hot)] hover:border-[color:var(--hot)] hover:text-white transition-colors flex items-center justify-center gap-2"
      >
        <Rocket size={13} /> Deep Dive
      </button>
    </div>
  );
}

function Cell({ label, value }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-widest text-[color:var(--muted)]">{label}</div>
      <div className="font-semibold">{value}</div>
    </div>
  );
}
